export { useQuery, useLazyQuery, useMutation } from '@vue/apollo-composable'
export { useMutationForm } from '@/composables/useMutationForm'
export { useArray } from '@jinkosoft/array'

import { useError } from "@jinkosoft/error";

import { useRoute, useRouter } from 'vue-router'

import { useSmartRouter } from '@jinkosoft/smart-router'

import { useFlashMessagesStore } from '@jinkosoft/flash-messages'
import { useBackRoute } from '@/composables/useBackRoute'
import { gql } from "graphql-tag";

import { useQueryConverter } from '@/composables/useQueryConverter'

import { usePreventKeyEvents } from "@jinkosoft/prevent-key-events"

import { useStripper } from "@jinkosoft/stripper"

import { useApolloExtension} from "@jinkosoft/apollo-extension"

import { useNormalizedGraphQLValidationErrors } from '@/composables/useNormalizedGraphQLValidationErrors'

import { usePageTitle } from "@/composables/front/usePageTitle.js"

import cloneDeep from 'lodash/cloneDeep'

import { useRecaptcha } from "@jinkosoft/recaptcha";

export { useFormatCurrency } from "@jinkosoft/number-format";

import { useI18n } from 'vue-i18n'

export function useGlobals(){

    const { t } = useI18n()

    const { showError } = useError();
    const { getBackRoute } = useBackRoute()
    const { replaceQuery } = useSmartRouter()
    const { addMessage: addFlashMessage } = useFlashMessagesStore()

    const {
        changePageTitle,
        watchPageTitleChange
    } = usePageTitle()

    const {
        verifyRecaptcha,
        appendRecaptchaScript
    } = useRecaptcha({
        siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    })

    const {
        getCreateRelationErrors,
        getUpdateRelationErrors,
        getRelationErrors,
    } = useNormalizedGraphQLValidationErrors()

    const {
        stripValueRecursive,
        stripKeyFromArray,
        stripValueFromArray,
        stripValuesFromArray,
        stripValuesRecursive
    } = useStripper()

    const { fromRoute, hasParam, fromObject } = useQueryConverter()

    const { preventByFlag } = usePreventKeyEvents()

    const { onResultReadyOnce } = useApolloExtension()

    const route = useRoute()
    const router = useRouter()

    return {
        t,

        fromRoute,
        fromObject,
        hasParam,

        showError,

        getBackRoute,
        replaceQuery,

        addFlashMessage,

        route,

        router,

        gql,

        cloneDeep,

        preventByFlag,

        stripValueRecursive,
        stripKeyFromArray,
        stripValueFromArray,
        stripValuesFromArray,
        stripValuesRecursive,

        onResultReadyOnce,

        getCreateRelationErrors,
        getUpdateRelationErrors,
        getRelationErrors,

        changePageTitle,

        verifyRecaptcha,
        appendRecaptchaScript
    }
}
